var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditEnabeledQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20C1.45 20 0.979167 19.8044 0.5875 19.4132C0.195833 19.0221 0 18.5518 0 18.0025V4.01998C0 3.47066 0.195833 3.00042 0.5875 2.60924C0.979167 2.21806 1.45 2.02247 2 2.02247H10.925L8.925 4.01998H2V18.0025H16V11.0612L18 9.06367V18.0025C18 18.5518 17.8042 19.0221 17.4125 19.4132C17.0208 19.8044 16.55 20 16 20H2ZM6 14.0075V9.7628L15.175 0.599251C15.375 0.399501 15.6 0.249688 15.85 0.149813C16.1 0.0499376 16.35 0 16.6 0C16.8667 0 17.1208 0.0499376 17.3625 0.149813C17.6042 0.249688 17.825 0.399501 18.025 0.599251L19.425 2.02247C19.6083 2.22222 19.75 2.44278 19.85 2.68414C19.95 2.92551 20 3.17104 20 3.42072C20 3.67041 19.9542 3.91594 19.8625 4.1573C19.7708 4.39867 19.625 4.61923 19.425 4.81898L10.25 14.0075H6ZM8 12.01H9.4L15.2 6.21723L14.5 5.5181L13.775 4.81898L8 10.5868V12.01Z",
    fill: "#0F2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEnabeledQuestion);
export default __webpack_public_path__ + "static/media/edit-enabeled-question.2b89ca413c27c2770577ba6b58353d32.svg";
export { ForwardRef as ReactComponent };